<template>
   <div :class="{'error-message': errortype=='error', 'alert-message': errortype=='alert'}"><slot></slot></div>
</template>
<script>
export default {
  props:{
    errortype:{
      type: String
    },
  },
  watch:{
    errortype(){
      setTimeout(function(){
       this.innerHTML=''
      }, 5000)
    }
  }
}
</script>